<template>
    <b-card>
        <b-card-body>
            <div class="animated fadeIn">

                <b-row>

                    <b-col md="6">
                        <b-form-group :label="'Тип'"  :label-cols="3" :horizontal="false">
                            <b-select
                                v-model.number="contractorTypeFilter"
                                :options="getTypes()"
                                label="title"
                                @change="applyContractorTypeFilter()"
                                class="form-contol"
                            ></b-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group label="Контрагент"  :label-cols="3" :horizontal="false">
                            <v-select
                                v-model="contractorFilter"
                                :options="getCompanies()"
                                placeholder="Выберите контрагента"
                                label="title"
                                @change="applyContractorFilter()"
                                class="form-contol"
                            ></v-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group label="Период: " :label-cols="3" :horizontal="false">
                            <div class="input-group">
                                <v-date-picker
                                    id="rangeCISelect"
                                    mode='range'
                                    v-model='rangeFilter'
                                    @change="applyRangeFilter()"
                                    @input="applyRangeFilter()"
                                >
                                    <b-form-input
                                        type="text"
                                        id="range_input"
                                        slot-scope="{ inputProps, inputEvents, isDragging }"
                                        class="form-control form-date-picker"
                                        readonly
                                        v-bind="inputProps"
                                        v-on="inputEvents" />
                                </v-date-picker>
                                <b-button type="button" variant="secondary"  @click='resetRangeFilter()'><i class="cui-circle-x icon"></i> </b-button>
                            </div>
                        </b-form-group>
                    </b-col>

                </b-row>

                <v-server-table :url="apiurl('finance/balance/table')"  :columns="columns" :options="options" :theme="theme" id="balancesTable" ref="balancesTable" class="table-sm">
                    <span slot="created_at" slot-scope="props">{{ printDateTime(props.row.created_at, true) }}</span>

                    <span slot="debet" slot-scope="props"   :class="props.row.debet<0?'text-danger':''">{{ formatPriceKop(props.row.debet) }}</span>
                    <span slot="feedebet" slot-scope="props"   :class="props.row.feedebet<0?'text-danger':''">{{ formatPriceKop(props.row.feedebet) }}</span>
                    <span slot="income" slot-scope="props"   :class="props.row.income<0?'text-danger':''">{{ formatPriceKop(props.row.income) }}</span>
                    <span slot="active" slot-scope="props"   :class="props.row.active<0?'text-danger':''">{{ formatPriceKop(props.row.active) }}</span>
                    <span slot="blocked" slot-scope="props"  :class="props.row.blocked<0?'text-danger':''">{{ formatPriceKop(props.row.blocked) }}</span>
                    <span slot="reserved" slot-scope="props" :class="props.row.reserved<0?'text-danger':''">{{ formatPriceKop(props.row.reserved) }}</span>
                    <span slot="closed" slot-scope="props"   :class="props.row.closed<0?'text-danger':''">{{ formatPriceKop(props.row.closed) }}</span>
                    <span slot="fee" slot-scope="props"      :class="props.row.fee<0?'text-danger':''">{{ formatPriceKop(props.row.fee) }}</span>
                    <span slot="penalty" slot-scope="props"  :class="props.row.penalty<0?'text-danger':''">{{ formatPriceKop(props.row.penalty) }}</span>
                    <span slot="credit" slot-scope="props"    :class="props.row.credit<0?'text-danger':''">{{ formatPriceKop(props.row.credit) }}</span>
                    <span slot="feecredit" slot-scope="props"    :class="props.row.feecredit<0?'text-danger':''">{{ formatPriceKop(props.row.feecredit) }}</span>
                    <span slot="outcome" slot-scope="props"  :class="props.row.outcome<0?'text-danger':''">{{ formatPriceKop(props.row.outcome) }}</span>
                    <span slot="s_active" slot-scope="props"   :class="props.row.s_active<0?'text-danger':''">{{ formatPriceKop(props.row.s_active) }}</span>
                    <span slot="s_reserved" slot-scope="props" :class="props.row.s_reserved<0?'text-danger':''">{{ formatPriceKop(props.row.s_reserved) }}</span>
                    <span slot="s_closed" slot-scope="props"   :class="props.row.s_closed<0?'text-danger':''">{{ formatPriceKop(props.row.s_closed) }}</span>
                    <span slot="s_fee" slot-scope="props"      :class="props.row.s_fee<0?'text-danger':''">{{ formatPriceKop(props.row.s_fee) }}</span>
                    <span slot="s_penalty" slot-scope="props"  :class="props.row.s_penalty<0?'text-danger':''">{{ formatPriceKop(props.row.s_penalty) }}</span>
                    <span slot="balance_a" slot-scope="props"  :class="balance_a(props.row)<0?'text-danger':''">{{ formatPriceKop(balance_a(props.row)) }}</span>
                    <span slot="balance_p" slot-scope="props"  :class="balance_p(props.row)<0?'text-danger':''">{{ formatPriceKop(balance_p(props.row)) }}</span>

                    <tr slot="appendBody">
                        <th >ИТОГО ПО СТРАНИЦЕ</th>
                        <template v-if="is_agency_mode">
                            <th style="text-align:right!important;" :class="debetTotal<0?'text-danger':''">{{ formatPriceKop(debetTotal) }}</th>
                            <th style="text-align:right!important;" :class="feedebetTotal<0?'text-danger':''">{{ formatPriceKop(feedebetTotal) }}</th>
                            <th style="text-align:right!important;" :class="incomeTotal<0?'text-danger':''">{{ formatPriceKop(incomeTotal) }}</th>
                            <th style="text-align:right!important;" :class="activeTotal<0?'text-danger':''">{{ formatPriceKop(activeTotal) }}</th>
                            <th style="text-align:right!important;" :class="blockedTotal<0?'text-danger':''">{{ formatPriceKop(blockedTotal) }}</th>
                            <th style="text-align:right!important;" :class="reservedTotal<0?'text-danger':''">{{ formatPriceKop(reservedTotal) }}</th>
                            <th style="text-align:right!important;" :class="closedTotal<0?'text-danger':''">{{ formatPriceKop(closedTotal) }}</th>
                            <th style="text-align:right!important;" :class="feeTotal<0?'text-danger':''">{{ formatPriceKop(feeTotal) }}</th>
                            <th style="text-align:right!important;" :class="penaltyTotal<0?'text-danger':''">{{ formatPriceKop(penaltyTotal) }}</th>
                            <th style="text-align:right!important;" :class="creditTotal<0?'text-danger':''">{{ formatPriceKop(creditTotal) }}</th>
                            <th style="text-align:right!important;" :class="feecreditTotal<0?'text-danger':''">{{ formatPriceKop(feecreditTotal) }}</th>
                            <th style="text-align:right!important;" :class="outcomeTotal<0?'text-danger':''">{{ formatPriceKop(outcomeTotal) }}</th>
                        </template>
                        <template v-if="is_hotel_mode">
                            <th style="text-align:right!important;" :class="creditTotal<0?'text-danger':''">{{ formatPriceKop(creditTotal) }}</th>
                            <th style="text-align:right!important;" :class="feecreditTotal<0?'text-danger':''">{{ formatPriceKop(feecreditTotal) }}</th>
                            <th style="text-align:right!important;" :class="outcomeTotal<0?'text-danger':''">{{ formatPriceKop(outcomeTotal) }}</th>
                            <th style="text-align:right!important;" :class="s_activeTotal<0?'text-danger':''">{{ formatPriceKop(s_activeTotal) }}</th>
                            <th style="text-align:right!important;" :class="s_reservedTotal<0?'text-danger':''">{{ formatPriceKop(s_reservedTotal) }}</th>
                            <th style="text-align:right!important;" :class="s_closedTotal<0?'text-danger':''">{{ formatPriceKop(s_closedTotal) }}</th>
                            <th style="text-align:right!important;" :class="s_feeTotal<0?'text-danger':''">{{ formatPriceKop(s_feeTotal) }}</th>
                            <th style="text-align:right!important;" :class="s_penaltyTotal<0?'text-danger':''">{{ formatPriceKop(s_penaltyTotal) }}</th>
                            <th style="text-align:right!important;" :class="debetTotal<0?'text-danger':''">{{ formatPriceKop(debetTotal) }}</th>
                            <th style="text-align:right!important;" :class="feedebetTotal<0?'text-danger':''">{{ formatPriceKop(feedebetTotal) }}</th>
                            <th style="text-align:right!important;" :class="incomeTotal<0?'text-danger':''">{{ formatPriceKop(incomeTotal) }}</th>
                        </template>
                        <th style="text-align:right!important;" :class="balance_aTotal<0?'text-danger':''">{{ formatPriceKop(balance_aTotal) }}</th>
                        <th style="text-align:right!important;" :class="balance_pTotal<0?'text-danger':''">{{ formatPriceKop(balance_pTotal) }}</th>
                    </tr>
                </v-server-table>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_company } from '@/functions/company.js';
    Vue.use(ServerTable)
    import {CONSTANTS} from '@/constants';
    import vSelect from 'vue-select';

    export default {
        name: 'NsbBuhBalances',
        components: { ServerTable, Event, vSelect },
        mixins: [functions, functions_loaders, functions_company],
        data: function () {
            return {
                columns_ag: ['contractor.title', 'debet', 'feedebet', 'income', 'active', 'blocked', 'reserved', 'closed', 'fee', 'penalty', 'credit', 'feecredit', 'outcome', 'balance_a', 'balance_p',],
                columns_ho: ['contractor.title', 'credit', 'feecredit', 'outcome', 's_active', 's_reserved', 's_closed', 's_fee', 's_penalty', 'debet', 'feedebet', 'income', 'balance_a', 'balance_p',],

                options: {
                    saveState: true,
                    headings: {
                        'contractor.title': 'котрагент',
                        created_at: 'создано',
                        debet: 'дебет',
                        feedebet: 'дебет по а/в',
                        income: 'поступление',
                        active: 'доступно',
                        blocked: 'заблокировано',
                        reserved: 'резерв',
                        closed: 'услуг оказано',
                        fee: 'вознаграждение',
                        penalty: 'штраф',
                        credit: 'кредит',
                        feecredit: 'кредит по а/в',
                        outcome: 'оплачено',

                        s_active: 'доступно в объекте',
                        s_reserved: 'резерв в объекте',
                        s_closed: 'услуг получено',
                        s_fee: 'вознаграждение объекта',
                        s_penalty: 'штраф объекта',

                        balance_a: 'актив',
                        balance_p: 'пассив',
                    },
                    sortable: [],
                    filterable: false ,
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    perPageValues:[10,25,50,100,250,500,1000],
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll'
                    },
                    templates: {},
                    customFilters: [
                        'range',
                        'contractor',
                        'contractor_type',
                    ],
                    initFilters: {
                        range:this.$store.state.financeFilters.rangeFilter,
                        contractor:this.$store.state.financeFilters.contractorFilter,
                        contractor_type:this.$store.state.financeFilters.contractorTypeFilter,
                    },
                    columnsClasses: {
                        id: 'center td-3',
                        created_at: 'center td-10',
                        debet: 'right td-7',
                        feedebet: 'right td-7',
                        income: 'right td-7',
                        active: 'right td-7',
                        blocked: 'right td-7',
                        reserved: 'right td-7',
                        closed: 'right td-7',
                        fee: 'right td-7',
                        penalty: 'right td-7',
                        credit: 'right td-7',
                        feecredit: 'right td-7',
                        outcome: 'right td-7',
                        s_active: 'right td-7',
                        s_reserved: 'right td-7',
                        s_closed: 'right td-7',
                        s_fee: 'right td-7',
                        s_penalty: 'right td-7',
                        balance_a: 'right td-7',
                        balance_p: 'right td-7',
                    },
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                },
                theme: 'bootstrap4',
                table_data: null,

                contractorFilter:null,
                contractorTypeFilter: 1,
                rangeFilter:null,
            }
        },
        methods: {
            balance_a: function(item) {
                return Number(item.debet) + Number(item.feedebet) + Number(item.outcome) +
                    Number(item.active) + Number(item.blocked) + Number(item.reserved) + Number(item.closed) + Number(item.penalty) +
                    Number(item.s_fee);
            },
            balance_p: function(item) {
                return Number(item.credit) + Number(item.feecredit) + Number(item.income) +
                    Number(item.fee)+
                    Number(item.s_active) + Number(item.s_reserved) + Number(item.s_closed) + Number(item.s_penalty);
            },
            getTypes: function() {
                return {
                    1:'Агентства',
                    2:'Объекты',
                };
            },
            getCompanies: function() {
                let self = this;
                return this.companies.filter(function(company) {
                    return company.type & self.contractorTypeFilter;
                });
            },
            applyRangeFilter: function() {
                this.saveFilter();
                Event.$emit('vue-tables.filter::range', this.rangeString);
            },
            resetRangeFilter: function() {
                this.rangeFilter = null;
                this.saveFilter();
            },
            applyContractorTypeFilter: function() {
                alert(11);
                console.log('applyContractorTypeFilter', this.contractorTypeFilter)
                this.contractorFilter = null;
                this.saveFilter();
                Event.$emit('vue-tables.filter::contractor', this.contractorFilter);
                Event.$emit('vue-tables.filter::contractor_type', this.contractorTypeFilter);
            },
            applyContractorFilter: function() {
                alert(22);
                this.saveFilter();
                Event.$emit('vue-tables.filter::contractor', this.contractorFilter);
            },
            saveFilter: function() {
                this.$store.commit('saveFinanceFilters', {
                    rangeFilter:this.rangeFilter,
                    contractorFilter:this.contractorFilter,
                    contractorTypeFilter:this.contractorTypeFilter,
                });
            },
            restoreFilter: function() {
                this.contractorTypeFilter = this.$store.state.financeFilters.contractorTypeFilter;
                if (!this.contractorTypeFilter) this.contractorTypeFilter=1;

                this.contractorFilter = this.$store.state.financeFilters.contractorFilter;
                if (!this.contractorFilter) this.contractorFilter=null;

                this.rangeFilter = Object.assign({}, this.$store.state.financeFilters.rangeFilter);
                if (!this.rangeFilter) this.rangeFilter=null;
            },
        },
        computed: {
            creditTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum + Number(item.credit) }, 0)
            },
            feecreditTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum + Number(item.feecredit) }, 0)
            },
            incomeTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum + Number(item.income) }, 0)
            },
            activeTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.active) }, 0)
            },
            blockedTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.blocked) }, 0)
            },
            reservedTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.reserved) }, 0)
            },
            closedTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.closed) }, 0.0)
            },
            feeTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.fee) }, 0.0)
            },
            penaltyTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.penalty) }, 0)
            },
            debetTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.debet) }, 0.0)
            },
            feedebetTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.feedebet) }, 0.0)
            },
            outcomeTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.outcome) }, 0.0)
            },

            s_activeTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.s_active) }, 0)
            },
            s_reservedTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.s_reserved) }, 0)
            },
            s_closedTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.s_closed) }, 0)
            },
            s_feeTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.s_fee) }, 0)
            },
            s_penaltyTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + Number(item.s_penalty) }, 0)
            },

            balance_aTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + this.balance_a(item) }, 0.0)
            },
            balance_pTotal() {
                if (!this.table_data) return 0;
                return this.table_data.reduce((accum, item) => { return accum  + this.balance_p(item) }, 0.0)
            },
            rangeString: function () {
                if (this.rangeFilter !== null)
                    return (new Date(this.rangeFilter.start).toLocaleDateString()) + '_' + (new Date(this.rangeFilter.end).toLocaleDateString())
                return null;
            },
            is_agency_mode: function() {
                return this.contractorTypeFilter === CONSTANTS.COMPANY_TYPE_AGENCY;
            },
            is_hotel_mode: function() {
                return this.contractorTypeFilter !== CONSTANTS.COMPANY_TYPE_AGENCY;
            },
            columns: function() {
                return this.is_agency_mode ? this.columns_ag : this.columns_ho;
            },
        },
        created: function() {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',(data)=>{ this.$eventHub.$emit('loading_end'); this.table_data = data.data; });
            this.loadCompanies();
        },
        mounted: function () {
            this.restoreFilter();
        },
    }
</script>
